import styled from 'styled-components'
import { BaseInput } from 'components/Inputs/Base'
import { LookButton, buttonLook } from 'components/Buttons/look'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 100px;
`

export const Row = styled(Container)`
  width: 100%;
  padding: 0px;
  gap: 10px;
  margin-bottom: 15px;
  flex-direction: row;
  align-items: flex-start;
`

export const FormField = styled(Container)`
  flex: 1;
  justify-content: flex-end;
  padding: 0px;
`

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: space-between;
`

export const Button = styled(LookButton).attrs(buttonLook({ variant: 'secondary' }))`
  width: 200px;
  align-self: center;
`

export const Input = styled(BaseInput)`
  width: 100%;
  margin: 0px 5px;
`

export const InfoText = styled.p`
  font-size: 14px;
  text-align: center;
  color: #FFFFFF;
  margin: 0px;
`

export const Label = styled(InfoText)`
  margin-bottom: 5px;
  color: #000000;
`

export const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  align-self: flex-start;
  margin-top: 24px;
  font-size: 14px;
  color: #000000;
`

export const WarningText = styled(InfoText)`
  color: #FF3939;
`

export const ErrorContainer = styled.div`
  padding: 9px;
  margin: 15px 0px;
  width: 100%;
  border-radius: 15px;
  align-items: center;
  background-color: #FF3939;
`

export const LinkButton = styled(LookButton).attrs(buttonLook({ variant: 'link' }))`
  align-self: flex-start;
  margin: 0px 5px 15px;
`
